<template>
    <div>
        <data-grid ref="list"
                   :settings="grid"
                   :page="page"
                   :storeDispatchList="loadGridData"
                   v-on:button-edit="$emit('openItem', $event)"
                   v-on:button-delete="deleteItem($event)"
                   v-on:changePage="$emit('changePage', $event)"
        />
    </div>
</template>

<script>
    import TheHeader from '../../Layout/TheHeader'
    import DataGrid from '../../../core/DataGrid/DataGrid'

    export default {
        components: {
            TheHeader,
            DataGrid
        },
        props: {
            page: {
                type: Number,
                default: 1,
                required: false,
            },
            type: {
                required: false,
            },
            visibleIdentifier: {
                type: Boolean,
                default: true,
                required: false,
            }
        },
        methods: {
            loadGridData(params) {
                if (this.type !== undefined) {
                    params.conditions.push({
                        key: 'type',
                        value: this.type
                    });
                }
                return this.$store.dispatch('templates/list', params);
            },
            deleteItem(item) {
                this.$store.dispatch('templates/remove', item.id).then((response) => {
                    this.$refs.list.fetchData();
                });
            }
        },
        data() {
            return {
                grid: {
                    buttons: [
                        {
                            type: 'button',
                            key: 'edit',
                            name: this.t('Edit'),
                            icon: 'eye',
                            styleClass: 'btn-primary btn-sm'
                        }, {
                            type: 'action',
                            key: 'delete',
                            name: this.t('Delete'),
                            icon: 'trash-alt',
                            modalText: this.t('Do you want to delete template?'),
                            styleClass: 'btn-danger btn-sm'
                        }
                    ],
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Subject'),
                            key: 'name',
                            scrollable: true,
                            filter: {
                                type: 'fulltext',
                                likeType: '%_like_',
                            }
                        }, {
                            type: 'string',
                            name: this.t('Identificator'),
                            key: 'identificator',
                            scrollable: true,
                            visible: this.visibleIdentifier,
                            filter: {
                                type: 'fulltext',
                                likeType: '%_like_',
                            }
                        }, {
                            type: 'bool',
                            name: this.t('Active'),
                            key: 'active',
                            scrollable: false,
                        },
                    ]
                },
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/Pages/Templates/List.vue